import { QaAgenda } from "apps/user/learner/api/coach-qa";

// An agenda's machine key as a tester reads it: "content_recommender" →
// "Content recommender".
export const humaniseAgenda = (conversationType: string): string =>
  conversationType.replace(/_/g, " ").replace(/^./, (c) => c.toUpperCase());

// A thread's agenda as the tester should read it: the blueprint's own name when
// the Configuration still serves that agenda, else the machine key humanised.
// The fallback is load-bearing — a thread can sit in an agenda this
// Configuration no longer serves, including one Ori moved it to mid-chat.
export const agendaLabel = (
  conversationType: string,
  agendas: QaAgenda[]
): string =>
  agendas.find((agenda) => agenda.conversation_type === conversationType)
    ?.name ?? humaniseAgenda(conversationType);
